import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M5.8335 30.8336V9.16699H34.1582V30.8336H5.8335ZM7.92745 28.7396H14.5771V11.261H7.92745V28.7396ZM16.671 28.7396H23.3207V11.261H16.671V28.7396ZM25.4146 28.7396H32.0642V11.261H25.4146V28.7396Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map